import { isEqual } from 'es-toolkit/compat';

export default function getChangedKeysByObjects<T extends Record<string, unknown>>(source: T, target: T): (keyof T)[] {
    return Object.keys(target)?.filter((key) => !isEqual(source?.[key], target?.[key]));
}
